import React, { memo } from 'react';
import { Button } from '@components/Button';
import { TextPairing } from '@components/TextPairing';
import ReactHtmlParser from 'react-html-parser';
import { ContentBox, StyledBox } from './HeroSection.styles';
import { useTranslation } from 'react-i18next';

export const HeroSectionContent: React.FC<{ id: string }> = memo(({ id }) => {
  const { t } = useTranslation('careers');
  const heroSectionData = t('heroSectionData');
  return (
    <ContentBox paddingX={7}>
      <TextPairing
        title={ReactHtmlParser(heroSectionData.title)}
        titleVariant="hed72Hero"
        titleColor={'neutra6'}
        titleTagName="h1"
        body={heroSectionData.body}
        bodyVariant="dek24"
        bodyColor={'neutra6'}
        textAlign="center"
        alignment={'center'}
      />
      <StyledBox marginTop={[7, 6]}>
        <Button id={`${id}ExploreCareers`} variant="primary" forwardedAs="a" href={t('allPostionsCta')}>
          {heroSectionData.cta}
        </Button>
      </StyledBox>
    </ContentBox>
  );
});
